import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import pkg from '../../package.json' with { type: 'json' };
/**
 * Bottom-of-shell footer. Shows the build version and a Chaosology
 * brand line. Used by both PlatformShell and ProductShell so it
 * appears on every authenticated route.
 *
 * The version comes from `package.json` at build time — bumped on each
 * release. No date — keeps the footer terse.
 */
export function AppFooter() {
    return (_jsxs("footer", { className: "mt-12 flex flex-wrap items-center justify-between gap-3 border-t border-[var(--line)] pt-4 text-[12px] text-[var(--ink-500)]", children: [_jsxs("span", { style: { fontFamily: 'var(--f-mono)' }, children: ["v", pkg.version] }), _jsxs("span", { children: ["A product of", ' ', _jsx("a", { href: "https://chaosology.com", target: "_blank", rel: "noreferrer", className: "font-medium text-[var(--ink-700)] underline decoration-[var(--ink-300)] underline-offset-2 transition-colors hover:text-[var(--royal)] hover:decoration-[var(--royal)]", children: "Chaosology" })] })] }));
}
